
<div style="max-height: 90%; max-width: 100%; overflow-y: auto; width: 100%; white-space: pre-wrap;">
    {{ askAIDisplay }}
</div>

<div style="display: flex; width: 100%; margin-top: 20px; margin-bottom: 10px;">
    <input [(ngModel)]="askAIQuestion" (keyup.enter)="askAI()" placeholder="Ask AI" style="width: 100%; height: 35px;" type="text" name="askAIQuestion"/>
    <!-- <button type="button" class="btn btn-success" style="padding-top: 3px; height: 35px; margin-left: 10px; width: 160px;" (click)="clearDisplay()">Clear History</button> -->
    <button type="button" class="btn btn-success" style="padding-top: 3px; height: 35px; margin-left: 10px; width: 210px;" (click)="newConversation()">New Conversation</button>
</div>

<!-- <div style="text-align: center;">
    <label style="font-size: 13px;">(Example Question - can you find a correlation between the battery voltage and cputemp for the selected dataset)</label>
</div> -->




